"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Wed Jun 27 2018
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var ValueWithUnitConverter_1 = require("../../core/conversions/ValueWithUnitConverter");

var DataDictionaryError_1 = require("../../core/model/data-dictionary/DataDictionaryError");

var utils_1 = require("../../core/utils");

var Product_1 = require("../model/Product");

var ProductFlag_1 = require("../model/ProductFlag");

var ProductConverter_1 = require("./ProductConverter");

var ProductEANConverter_1 = require("./ProductEANConverter");
/**
 * Default implementation of ProductConverter.
 *
 * @author JMe
 * @author Jaroslav Sevcik
 */


var ProductConverterImpl =
/*#__PURE__*/
function (_ProductConverter_1$P) {
  _inherits(ProductConverterImpl, _ProductConverter_1$P);

  function ProductConverterImpl(productEANConverter) {
    var _this;

    _classCallCheck(this, ProductConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductConverterImpl).call(this));
    _this.productEANConverter = productEANConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ProductConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new Product_1.Product(Product_1.Product.schema.id.valueOf(conversions.documentToClassId(source)), Product_1.Product.schema.externalId.valueOfField(source), Product_1.Product.schema.numericId.valueOfField(source), Product_1.Product.schema.name.valueOfField(source), Product_1.Product.schema.familyId.valueOf(conversions.toClassReferenceId(source.familyId)), Product_1.Product.schema.description.valueOfField(source), Product_1.Product.schema.eans.valueOf(conversions.asObjectList(source, 'eans', function (document) {
        return _this2.productEANConverter.toObject(document, conversions);
      })), Product_1.Product.schema.categoryIds.valueOf(conversions.asClassReferenceIdsList(source, 'categoryIds')), Product_1.Product.schema.productSensitivityId.valueOf(conversions.toClassReferenceId(source.productSensitivityId)), Product_1.Product.schema.tierId.valueOf(conversions.toClassReferenceId(source.tierId)), conversions.asFlagSet(source.flags, ProductFlag_1.ProductFlag), Product_1.Product.schema.calibratedProductId.valueOf(conversions.toClassReferenceId(source.calibratedProductId)), Product_1.Product.schema.predecessorId.valueOf(conversions.toClassReferenceId(source.predecessorId)), source.classification, conversions.asObjectOpt(source, 'dimensions', this.deserializeDimensions(conversions)), Product_1.Product.schema.expiration.valueOfField(source), Product_1.Product.schema.supplierId.valueOf(conversions.toClassReferenceId(source.supplierId)), Product_1.Product.schema.supplierIds.valueOf(conversions.asObjectList(source, 'supplierIds', function (value) {
        if (utils_1.Utils.isValueMissing(value)) {
          throw new DataDictionaryError_1.DataDictionaryError("supplier id cannot be empty!");
        }

        return conversions.toClassReferenceId(value);
      })), Product_1.Product.schema.active.valueOfField(source), Product_1.Product.schema.measureUnitId.valueOf(conversions.toClassReferenceId(source.measureUnitId)), conversions.asObject(source, 'packageSize', ValueWithUnitConverter_1.ValueWithUnitConverter.deserialize(conversions)), Product_1.Product.schema.numberOfProductBindings.valueOfField(source), Product_1.Product.schema.newlyListedIntervalStart.valueOfField(source), Product_1.Product.schema.newlyListedIntervalEnd.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        externalId: source.externalId,
        numericId: source.numericId,
        name: source.name,
        familyId: conversions.toDocumentReferenceId(source.familyId),
        description: source.description,
        eans: conversions.asObjectArray(source, 'eans', function (productEAN) {
          return _this3.productEANConverter.toDocument(productEAN, conversions);
        }),
        categoryIds: conversions.asObjectArray(source, 'categoryIds', function (id) {
          return conversions.toDocumentReferenceId(id);
        }),
        productSensitivityId: conversions.toDocumentReferenceId(source.productSensitivityId),
        tierId: conversions.toDocumentReferenceId(source.tierId),
        flags: source.flags.serialize(),
        calibratedProductId: conversions.toDocumentReferenceId(source.calibratedProductId),
        predecessorId: conversions.toDocumentReferenceId(source.predecessorId),
        classification: source.classification,
        dimensions: conversions.asObjectOpt(source, 'dimensions', this.serializeDimensions(conversions)),
        expiration: source.expiration,
        supplierId: conversions.toDocumentReferenceId(source.supplierId),
        supplierIds: conversions.asObjectArray(source, 'supplierIds', function (id) {
          return conversions.toDocumentReferenceId(id);
        }),
        active: source.active,
        measureUnitId: conversions.toDocumentReferenceId(source.measureUnitId),
        packageSize: conversions.asObject(source, 'packageSize', ValueWithUnitConverter_1.ValueWithUnitConverter.serialize(conversions)),
        numberOfProductBindings: source.numberOfProductBindings,
        newlyListedIntervalStart: source.newlyListedIntervalStart && conversions.fromDate(source.newlyListedIntervalStart),
        newlyListedIntervalEnd: source.newlyListedIntervalEnd && conversions.fromDate(source.newlyListedIntervalEnd)
      });
      return result;
    }
  }, {
    key: "deserializeDimensions",
    value: function deserializeDimensions(conversions) {
      return function (document) {
        return {
          width: document.width ? conversions.toBigNumber(document.width) : null,
          height: document.height ? conversions.toBigNumber(document.height) : null,
          length: document.length ? conversions.toBigNumber(document.length) : null,
          weight: document.weight ? conversions.toBigNumber(document.weight) : null
        };
      };
    }
  }, {
    key: "serializeDimensions",
    value: function serializeDimensions(conversions) {
      return function (object) {
        return {
          width: object.width ? conversions.fromBigNumber(object.width) : null,
          height: object.height ? conversions.fromBigNumber(object.height) : null,
          length: object.length ? conversions.fromBigNumber(object.length) : null,
          weight: object.weight ? conversions.fromBigNumber(object.weight) : null
        };
      };
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toProductDataForOptTraining",
    value: function toProductDataForOptTraining(source, conversions) {
      return {
        id: Product_1.Product.schema.id.valueOf(conversions.documentToClassId(source)),
        numericId: Product_1.Product.schema.numericId.valueOfField(source),
        name: Product_1.Product.schema.name.valueOfField(source),
        familyId: Product_1.Product.schema.familyId.valueOf(conversions.toClassReferenceId(source.familyId)),
        categoryIds: Product_1.Product.schema.categoryIds.valueOf(conversions.asClassReferenceIdsList(source, 'categoryIds')),
        flags: conversions.asFlagSet(source.flags, ProductFlag_1.ProductFlag),
        active: Product_1.Product.schema.active.valueOfField(source),
        packageSize: conversions.asObject(source, 'packageSize', ValueWithUnitConverter_1.ValueWithUnitConverter.deserialize(conversions)),
        vatIds: conversions.asObjectList(source, 'vatIds', function (id) {
          return conversions.toClassReferenceId(id);
        })
      };
    }
  }]);

  return ProductConverterImpl;
}(ProductConverter_1.ProductConverter);

ProductConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [ProductEANConverter_1.ProductEANConverter])], ProductConverterImpl);
exports.ProductConverterImpl = ProductConverterImpl;